import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-topic-wrapper',
    templateUrl: './topic-wrapper.component.html',
    styleUrls: ['./topic-wrapper.component.css']
})
export class TopicWrapperComponent {
  @Input() topic;
  @Input() locale;

  @Output() onClick = new EventEmitter<any>();
  onTopicClick($event) {
    this.onClick.emit($event);
  }

}
